import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
})

export default TicketAdvancedLayout;